// --- Our Modules --------------------------------------------------------------------------------
import { pressToOpen } from "@/utils";
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    icon: TyIconName;
    count: number;
    label: string;
    /** Already past its date, or about to be. Nothing in this row is ever green. */
    tone: "late" | "soon";
    /** Absent where there is no screen to land on — two of these rows have none yet. */
    onOpen?: () => void;
};

/**
 * One piece of outstanding work, as a tile in the row Home opens with. It sits beside `FollowUpCard`
 * and has to read as the same kind of thing: same height, same icon box, same place for the label —
 * a row where every other card is shaped differently is a row nobody scans, they read it.
 */
export default function WorkCard({ icon, count, label, tone, onOpen }: Props) {
    return (
        <article
            className={`work-card${onOpen ? " work-card--opens" : ""}`}
            data-tone={tone}
            role={onOpen ? "button" : undefined}
            tabIndex={onOpen ? 0 : undefined}
            onClick={onOpen}
            onKeyDown={onOpen ? pressToOpen(onOpen) : undefined}
        >
            <span className="work-card__icon">
                <Icon name={icon} size={20} />
            </span>

            <div className="work-card__text">
                <strong className="work-card__count">{count}</strong>
                <span className="work-card__label">{label}</span>
            </div>
        </article>
    );
}
